import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CadastroGrupo } from '../interfaces/cadastro-grupo';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { ClassificacaoGerencial } from '../interfaces/classificacao-gerencial';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class ClassificacaoGerencialService {

  readonly path = '/classe/gerencial';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }

  create(): Observable<ClassificacaoGerencial> {
    return this.http.post<ClassificacaoGerencial>(`${this.jwtAuthService.apiUrl + this.path}`, null);
  }

  saveOrUpdate(classificacaoG: ClassificacaoGerencial): Observable<ClassificacaoGerencial> {
    return this.http.put<ClassificacaoGerencial>(`${this.jwtAuthService.apiUrl + this.path}`, classificacaoG);
  }

  getClassificacaoG(id: number ): Observable<ClassificacaoGerencial> {
    return this.http.get<ClassificacaoGerencial>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

  getClassificacaoGPage(page?: number, size?: number,
    order?: string, direction?: string): Observable<PageResult<ClassificacaoGerencial>> {
    let params = new HttpParams()
      .set('page', String(page ?? 1))
      .set('size', String(size ?? 20));

    if (order) {
      params = params.set('order', order);
    }
    if (direction) {
      params = params.set('direction', direction);
    }

    return this.http.get<PageResult<ClassificacaoGerencial>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/`, { params });
  }

  getClassificacaoGPageSearch(page?: number, size?: number,  search?: string,
    order?: string, direction?: string): Observable<PageResult<ClassificacaoGerencial>> {
    let params = new HttpParams()
      .set('page', String(page ?? 1))
      .set('size', String(size ?? 20))
      .set('search', (search ?? '').trim());

    if (order) {
      params = params.set('order', order);
    }
    if (direction) {
      params = params.set('direction', direction);
    }

    return this.http.get<PageResult<ClassificacaoGerencial>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/`, { params });
  }
  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }
}
